class start {
  constructor(data) {
    if (data) {
      this.type = data.type;
    }
    const sessionUser = JSON.parse(sessionStorage.getItem("user"));
    this.items = {
      id: 30001,
      name: "Start Text",
      type: "start",
      slideimg: "/doctorassistant/dia.jpg",
      options: [],
      backtostart: false,
      text: [
        `<p>Hello, ${sessionUser.userName}! 👋 Welcome to <strong>WEB<span style="color: #4fc4cc;">DOC</span></strong>.</p>`,
      ],
    };
  }

  async getAllItems() {
    if (this.type === "start") {
      return this.items;
    } else {
      sessionStorage.removeItem("travel_information");
    }
    const savedItems = await this.saveToAPI();
    return savedItems;
  }

  // Get package options for payment
  getStartOptions() {
    return [
      {
        id: 40012,
        text: "Elite",
        name: "Elite Plan",
        price: "",
        type: "zone",
        desc: "I’d like to get the Elite Plan",
        key: "type",
        value: 0,
      },
      {
        id: 40012,
        text: "Plantinum",
        name: "Plantinum plan",
        price: "",
        type: "zone",
        desc: "I’d like to get the Plantinum Plan",
        key: "type",
        value: 1,
      },
      {
        id: 40011,
        text: "Gold",
        name: "Gold Plan",
        price: "",
        type: "zone",
        desc: "I’d like to get the Gold Plan",
        key: "type",
        value: 2,
      },
      {
        id: 40011,
        text: "Silver",
        name: "Silver Plan",
        price: "",
        type: "zone",
        desc: "I’d like to get the Silver Plan",
        key: "type",
        value: 3,
      },
      {
        id: 40011,
        text: "Standard",
        name: "Standard Plan",
        price: "",
        type: "zone",
        desc: "I’d like to get the Standard Plan",
        key: "type",
        value: 4,
      },
    ];
  }

  getExistingUserOptions() {
    return [
      {
        id: 40012,
        text: "My Active Policies",
        name: "My Active Policies",
        price: this.price,
        type: "getmysavedpolicy",
        desc: "My Active Policies",
        inputtype: "button",
      },
    ];
  }

  // Method to send the car information to the API
  async saveToAPI() {
    const MEDICAL_LIMITS = [
      "$150,000",
      "$100,000",
      "$50,000",
      "$25,000",
      "$10,000",
    ];
    const PLAN_IDS = ["1031", "1032", "1033", "1034", "1035"];
    const PASSPORT_LIMITS = ["$600", "$500", "$400", "$300", "$200"];
    const PA_LIMITS = ["$30,000", "$25,000", "$20,000", "$10,000", "$5,000"];
    const TRAVEL_API_BASE =
      "https://miniappeasypaisa.webddocsystems.com/public/api/v1";
    const user = JSON.parse(sessionStorage.getItem("user"));

    try {
      const res = await fetch(
        `${TRAVEL_API_BASE}/travel-insurance/subscription?customerNumber=${user.userMsisdn}&service=TravelInsurance`,
        // { headers: { Authorization: AUTH_HEADER } }
      );
      const response = await res.json();
      if (response.responseCode === "0000") {
        const data = response.data;
        const index = PLAN_IDS.indexOf(data.planID);

        const COVERAGE_DETAILS = [
          ["Emergency Medical (Accident/Illness)", MEDICAL_LIMITS[index], true],
          ["COVID-19 Emergency Medical", "$35,000 (all plans)", false],
          ["Emergency Dental Care", "$600 (Excess: $60)", false],
          ["Medical Evacuation & Repatriation", "Actual Expenses", true],
          ["Repatriation of Mortal Remains", "Actual Expenses", true],
          [
            "Compassionate Visit (Family Member)",
            "$100/day, Max $1,000",
            false,
          ],
          ["Trip Cancellation", "$1,000", false],
          ["Delayed Departure", "$1,000", false],
          ["Loss of Checked-In Luggage", "$1,000", false],
          ["Loss of Passport", PASSPORT_LIMITS[index], false],
          ["Loss of Credit Card (first 24 hrs)", "$2,000", false],
          ["Accidental Death (Common Carrier)", PA_LIMITS[index], false],
          ["Bail Bond Advance", "$12,000", false],
          ["24/7 Assistance Services", "Included", true],
        ];

        const coverageHTML = COVERAGE_DETAILS.map(
          ([label, value, green]) => `
    <div class="d-flex justify-content-between align-items-center border-bottom py-2">
      <span class="${green ? "fw-bold text-success" : ""}">
        ${label}
      </span>
      <span class="${green ? "text-success fw-bold" : "text-muted"}">
        ${value}
      </span>
    </div>
  `,
        ).join("");

        this.items.text.push(`
  <div class="card shadow-sm border-0">
    <div class="card-body p-2">

     
      <div class="bg-success p-3 rounded text-white text-center mb-3">
        <div class="fs-4">✈️</div>
        <h6 class="fw-bold mb-1">Travel Insurance Active</h6>
        <small>${data.planName} Plan - ${data.coverageTypeLabel}</small>
        <div class="fw-bold mt-1">
          Rs. ${Number(data.finalPremiumPKR).toLocaleString("en-PK")}
        </div>
      </div>

    
      <div class="table-responsive">
        <table class="table table-sm align-middle mb-2">
          <tbody>

            <tr>
              <td class="text-muted">Medical Coverage</td>
              <td class="text-end fw-semibold">${data.medicalCoverageLimit}</td>
            </tr>

            <tr>
              <td class="text-muted">Trip Duration</td>
              <td class="text-end">${data.tripDurationLabel}</td>
            </tr>

            <tr>
              <td class="text-muted">Coverage Type</td>
              <td class="text-end">${data.coverageTypeLabel}</td>
            </tr>

            <tr>
              <td class="text-muted">Zone</td>
              <td class="text-end">${data.coverageZoneLabel}</td>
            </tr>

            <tr>
              <td class="text-muted">Age</td>
              <td class="text-end">${data.ageOfInsured}</td>
            </tr>

            <tr>
              <td class="text-muted">Age Loading</td>
              <td class="text-end">
                <span class="badge bg-success">${data.ageLoadingLabel}</span>
              </td>
            </tr>

          </tbody>
        </table>
      </div>

     
      <div class="mt-3">
        <div class="table-responsive">
          <table class="table table-sm align-middle">
            <tbody>
              ${COVERAGE_DETAILS.map(
                ([label, value, green]) => `
                  <tr>
                    <td class="small ${green ? "fw-semibold text-success" : "text-muted"}">
                      ${label}
                    </td>
                    <td class="text-end small ${green ? "fw-bold text-success" : ""}">
                      ${value}
                    </td>
                  </tr>
                `,
              ).join("")}
            </tbody>
          </table>
        </div>
      </div>

   
      <div class="mt-3">
        <table class="table table-sm mb-0">
          <tbody>
            <tr>
              <td class="text-muted">Base Premium (USD)</td>
              <td class="text-end">$${data.basePremiumUSD}</td>
            </tr>
            <tr>
              <td class="text-muted">Final Premium (USD)</td>
              <td class="text-end">$${data.finalPremiumUSD}</td>
            </tr>
            <tr>
              <td class="fw-bold">Final Premium (PKR)</td>
              <td class="text-end text-success fw-bold">
                Rs. ${Number(data.finalPremiumPKR).toLocaleString("en-PK")}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
`);
        //       this.items.text.push(`
        // <div class="card shadow-sm border-0">
        //   <div class="card-body" >

        //     <div class="bg-success p-4 rounded mb-4 text-white text-center">
        //       <div class="text-center fs-2">✈️</div>
        //     <h5 class="font-weight-bold card-title text-center"> Travel Insurance Active </h5>
        //      <p class=" mb-1 ">
        //       ${data.planName} Plan - ${data.coverageTypeLabel}
        //     </p>
        //      <span class="fw-bold">
        //           Rs. ${Number(data.finalPremiumPKR).toLocaleString("en-PK")}
        //         </span>
        //     </div>

        //     <div class="row mb-2">

        //         <div class="col-md-6">
        //         <strong>Medical Coverage:</strong> ${data.medicalCoverageLimit}
        //       </div>
        //       <div class="col-md-6">
        //         <strong>Trip Duration:</strong> ${data.tripDurationLabel}
        //       </div>
        //     </div>

        //     <div class="row mb-2">
        //       <div class="col-md-6">
        //         <strong>Coverage Type:</strong> ${data.coverageTypeLabel}
        //       </div>

        //     </div>
        //     <div class="mt-3">
        //       <h6 class="fw-bold mb-2">Coverage Details</h6>
        //       ${coverageHTML}
        //     </div>
        //     <div class="row mb-2">
        //       <div class="col-md-6">
        //         <strong>Age:</strong> ${data.ageOfInsured}
        //       </div>
        //       <div class="col-md-6">
        //         <strong>Age Loading:</strong>
        //         <span class="badge bg-success text-white">${data.ageLoadingLabel}</span>
        //       </div>
        //        <div class="col-md-6">
        //         <strong>Zone:</strong> ${data.coverageZoneLabel}
        //       </div>
        //     </div>

        //     <hr/>

        //     <div class="row mb-2">
        //       <div class="col-md-6">
        //         <strong>Base Premium (USD):</strong> $${data.basePremiumUSD}
        //       </div>
        //       <div class="col-md-6">
        //         <strong>Final Premium (USD):</strong> $${data.finalPremiumUSD}
        //       </div>

        //     </div>

        //     <div class="row mb-3">
        //       <div class="col-md-12">
        //         <strong>Final Premium (PKR):</strong>
        //         <span class="text-success fw-bold">
        //           Rs. ${Number(data.finalPremiumPKR).toLocaleString("en-PK")}
        //         </span>
        //       </div>
        //     </div>
        //   </div>
        // </div>
        //     `);

        this.items.options = [];
      } else {
        this.items.text.push(
          `<p>Please select the travel plan that best suits your needs:</p>`,
        );

        this.items.options = this.getStartOptions();
      }
    } catch (error) {
      console.error("Error saving data:", error);
      this.items.text = "Your quotation save failed.";
      this.items.issuccess = false;
    }

    return this.items;
  }
}

export default start;
